// extracted by mini-css-extract-plugin
export default {"container":"PuzzleGrid_container__otHVy","item":"PuzzleGrid_item__KF6Tj","hovered":"PuzzleGrid_hovered__o7QcA"};